import { render, staticRenderFns } from "./uploader-imgs.vue?vue&type=template&id=d7b81272&scoped=true&"
import script from "./uploader-imgs.vue?vue&type=script&lang=js&"
export * from "./uploader-imgs.vue?vue&type=script&lang=js&"
import style0 from "./uploader-imgs.vue?vue&type=style&index=0&id=d7b81272&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b81272",
  null
  
)

export default component.exports